'use strict';

const { find } = require("lodash");

function ctrl($scope, $http, Global, settings, $location) {
    $scope.global = Global;
    $scope.global.operations = {success:"Success", warning:"Warning", error:"Error"};
    alertify.defaults.theme.ok = "button-success pure-button";
    alertify.defaults.theme.cancel = "pure-button";
    alertify.set('notifier','position', 'bottom-center');
    if ($scope.global.user.user_level != "superadmin"){
        $location.url('/live');
    }
    let model = this;
    model.settings = settings;
    model.feeds = [];
    model.regexs = [];
    model.feeds_per_sensor  = [];
    model.light_feeds  = [];
    model.modal_regexs= [];
    model.sensors = [];
    model.help_test = '';
    model.btnSensorFeeds = false;
    model.btnFeeds = false;

    //Get all feeds
    model.getFeeds = () => {
        $http({
            method: 'GET',
            url: api+'/api/feeds/getAll'
        }).success(function (data){
            //tmpname is used to avoid visual confusion if name is edited
            for (let i = 0; i <= data.length-1;i++) {
                data[i].tmpname = data[i].name;
                data[i].ioc_severity = data[i].ioc_severity.toString()
                if(data[i].last_run!=0){
                    data[i].last_run = timeConverter(data[i].last_run)
                }else{
                    data[i].last_run = "Someday"
                }
            }
            model.feeds = data;
        })
    }

    model.getFeeds()
    // Load all the sensors
    model.loadSensors = () => { 
        $http({
            method: 'GET',
            url: api+'/api/landing/getSensors'
        }).success(function (data){
            model.sensors = data;
        })
    }

    // As the sensor tab is the first to show, it should be ready on page load
    model.loadSensors();

    // This is for store the relation between sensors and the feeds that the should use
    model.saveSensorFeeds = (sensor_id) =>{
        model.btnSensorFeeds = true;
        let feedsSelected = [];
        for(let i=0; i<= model.feeds.length-1 ; i++){
            console.log(i,document.getElementById(sensor_id+'rememberMe'+i))
            if(document.getElementById(sensor_id+'rememberMe'+i).checked){
                feedsSelected.push({sensor_id:sensor_id,feed_id:model.feeds[i].id})
            }
        }
        $http({
            method: 'POST',
            url: api+'/api/feeds_sensor/save',
            data: {
                sensor_id: sensor_id,
                feeds: feedsSelected
            }
        }).success(function (){
            showMsg($scope.global.operations.success,"Data has been successfully saved!")
            model.btnSensorFeeds = false;
        })
        .error((error)=>{alertError(error);model.btnSensorFeeds = false;})
    }
    // This weill load the feeds that were selected before and check the checkboxes
    model.loadFeedsPerSensor = (sensor_id) => { 
        $http({
            method: 'POST',
            url: api+'/api/feeds_sensor/getPerSensor',
            data: {
                sensor_id: sensor_id
            }
        })
        .success(function (data){
            data.forEach(element => {
                let index = model.feeds.findIndex(ele => ele.id===element.feed_id)
                document.getElementById(sensor_id+'rememberMe'+index).checked = true;
            })
        })
    }

    //Get all the regexs
    model.getRegexes = () => {
        $http({
            method: 'GET',
            url: api+'/api/regex/getAll'
        }).success(function (data){
            model.regexs = data;
            model.modal_regexs = angular.copy(data);
        })
    }
    model.getRegexes();

    model.addFeed = function(){            
        if(model.feeds.some((ele)=>ele.tmpname==="New feed")){
            showMsg($scope.global.operations.warning,"A new feed is being created already, please save it before creating a new one!");
            return;
        }
        model.feeds.push({tmpname:"New feed", ioc_type:"",frequency:""});
    }

    // This function is for the buttons with the sensor name on Sensors tab 
    model.openSensor = function(index, sensor_id){
        let i, tabContent, tabLinks;
        tabContent = document.getElementsByName("sensorContent");
        for (i = 0; i < tabContent.length  ; i++) {
            tabContent[i].style.display = "none";
        }
        tabLinks = document.getElementsByName("sensorLink");
        for (i = 0; i < tabContent.length -1 ; i++) {
            tabLinks[i].className = tabLinks[i].className.replace(" active", "");
        }
        document.getElementById(sensor_id).style.display = "block";
        tabLinks[index].classList.add('active');
        model.loadFeedsPerSensor(sensor_id)
    }

    // This function is for the buttons with the feed name on Feeds tab 
    model.openFeed = function(index, feed){
        let i, tabContent, tabLinks;
        tabContent = document.getElementsByName("feed");
        for (i = 0; i < tabContent.length  ; i++) {
            tabContent[i].style.display = "none";
        }
        tabLinks = document.getElementsByName("feedlink");
        for (i = 0; i < tabContent.length -1 ; i++) {
            tabLinks[i].className = tabLinks[i].className.replace(" active", "");
        }
        document.getElementById(feed.tmpname).style.display = "block";
        tabLinks[index].classList.add('active');
    }

    model.saveFeed = (feed) =>{
        model.btnFeeds = true;
        if(feed.helper===undefined){
            feed.helper="";
        }
        let count = 0;
        model.feeds.map(function(e) { return e.name; }).forEach((e)=>(e==feed.name)?count++:'');
        if(count>1){
            showMsg($scope.global.operations.error,"There cannot be two feeds with the same name!")
            return
        }
        if(feed.id!==undefined){
            $http({
                method: 'POST',
                url: api+'/api/feeds/update',
                data: {
                    feed: feed
                }
            })
            .success(function () {
                feed.tmpname = feed.name;
                model.getFeeds();
                model.btnFeeds = false;
                showMsg($scope.global.operations.success,"Data has been successfully updated!")
            })
            .error((error)=>{alertError(error);model.btnFeeds = false;})
        }else{
            $http({
                method: 'POST',
                url: api+'/api/feeds/save',
                data: {
                    feed: feed
                }
            })
            .success(function () {
                feed.tmpname = feed.name;
                model.getFeeds();
                //document.getElementsByName("feed")[0].style.display="";
                showMsg($scope.global.operations.success,"Data has been successfully saved!")
                model.btnFeeds = false;
            })
            .error((error)=>{alertError(error);model.btnFeeds = false;})
        }
    };

    model.saveRegexs = () => {
        let updatedFeeds=  model.modal_regexs.filter((newReg,index)=>{
            if((model.regexs[index]!==undefined)&&((model.regexs[index].regex !== newReg.regex)||(model.regexs[index].name !== newReg.name))){
                newReg.oldName=model.regexs[index].name;
                return newReg
            }
        })
        if(updatedFeeds.length > 0){
            let used = model.feeds.filter((feed)=>{ 
                let found = updatedFeeds.find(regex=>{return feed.regex===regex.oldName?regex.oldName:""})
                if(found!==undefined){
                    return feed.regex===found.oldName
                }})
            let usedNames = used.map((ele)=>ele.name);
            alertify.confirm('Update confirmation',("It looks like the modified regex(s) are being used by "+usedNames+". This might cause a miss behaviour, are you sure you want to continue?"), 
            function(){ 
                $http({
                    method: 'POST',
                    url: api+'/api/regex/save',
                    data: {
                        values: model.modal_regexs
                    }
                })
                .success(function () {
                    showMsg($scope.global.operations.success,"Data has been successfully saved!")
                })
                .error((error)=>alertError(error))
            },{});
        }else{
            $http({
                method: 'POST',
                url: api+'/api/regex/save',
                data: {
                    values: model.modal_regexs
                }
            })
            .success(function () {
                showMsg($scope.global.operations.success,"Data has been successfully saved!")
            })
            .error((error)=>alertError(error))
        }
    };


    model.deleteFeed = (feed, index) => {
        let conf = feed.id!==undefined?'Are you sure? If the feed is associated with a sensor, the relation will be also deleted.':'Do you want to cancel this '
        alertify.confirm('Delete confirmation',conf, 
            function(){ 
                if(feed.id!==undefined){
                    $http({
                        method: 'POST',
                        url: api+'/api/feeds/delete',
                        data: {
                            feed: feed
                        }
                        }) 
                        .success(function (data) {
                            model.feeds.splice(index, 1);
                            showMsg($scope.global.operations.success,"Data has been successfully deleted!")
                            document.getElementById('emptyFeed').style.display = "block";
                        })
                        .error((error)=>alertError(error))
                }else{
                    model.feeds.splice(index, 1);
                    showMsg($scope.global.operations.success,"Data has been successfully deleted!")
                    document.getElementById('emptyFeed').style.display = "block";
                }
            },{});            
    };

    model.loadRegexs = () => {
        //model.modal_regexs = angular.copy(model.regexs);
        model.modal_regexs.forEach(element=>element.repeatedN = false)
        model.modal_regexs.forEach(element=>element.repeatedR = false)
        model.cleanRegex();
        model.validateRegex({name:'',regex:''});;
    }

    model.tryRegex = () => {
        let regExp = /.*/g , regHelp = /^.*/;
        if(model.regex_test==='regex_demo'){
            regExp = new RegExp(/^.*\,([0-9.]*)\,/,'gm');
            model.regPre = '2021-02-09 09:34:40,119.45.183.69,8880\n'+
            '2021-02-09 08:35:12,139.28.235.223,8808\n'+
            '2021-02-08 20:04:37,179.43.166.30,4782\n'+
            '2021-02-08 18:03:27,185.140.53.137,4723\n';
            model.regOut = getRegexs(model.regPre,regExp);
            model.help_test = '';
            model.helpOut = '';
            document.getElementById('help_out').style.display="none";
        }else if(model.regex_test==='regex_helper' || model.help_test==='helper_demo'){
            model.regex_test='regex_helper';
            model.help_test='helper_demo';
            model.regPre='alert tcp $HOME_NET any -> [103.110.53.174,103.150.68.124,103.244.206.74,103.40.116.68,103.41.110.115,103.61.101.11,103.69.216.154,103.86.49.11,103.89.252.130,103.91.244.102,103.91.244.50,103.93.220.182,103.94.7.43,104.131.123.136] any (msg:"ET CNC Feodo Tracker Reported CnC Server TCP group 1"; flags:S; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404300; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signature_severity Major, created_at 2014_11_04, updated_at 2021_02_09;)\n'+
            'alert udp $HOME_NET any -> [103.110.53.174,103.150.68.124,103.244.206.74,103.40.116.68,103.41.110.115,103.61.101.11,103.69.216.154,103.86.49.11,103.89.252.130,103.91.244.102,103.91.244.50,103.93.220.182,103.94.7.43,104.131.123.136] any (msg:"ET CNC Feodo Tracker Reported CnC Server UDP group 1"; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404301; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signature_severity Major, created_at 2014_11_04, updated_at 2021_02_09;)\n'+
            'alert tcp $HOME_NET any -> [104.131.164.93,104.131.44.150,104.161.32.108,104.236.52.89,105.209.235.113,107.172.188.113,107.172.29.108,109.101.137.162,109.116.245.80,110.142.236.207,110.145.11.73,110.172.180.180,110.37.224.243,110.39.160.38] any (msg:"ET CNC Feodo Tracker Reported CnC Server TCP group 2"; flags:S; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404302; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signature_severity Major, created_at 2014_11_04, updated_at 2021_02_09;)\n'+
            'alert udp $HOME_NET any -> [104.131.164.93,104.131.44.150,104.161.32.108,104.236.52.89,105.209.235.113,107.172.188.113,107.172.29.108,109.101.137.162,109.116.245.80,110.142.236.207,110.145.11.73,110.172.180.180,110.37.224.243,110.39.160.38] any (msg:"ET CNC Feodo Tracker Reported CnC Server UDP group 2"; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404303; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signa';
            regExp = new RegExp(/^.*\[([0-9.,]*)\]/,'gm');
            regHelp = new RegExp(/([^,]*)/,'gm');
            document.getElementById('help_out').style.display="block";
            model.helpOut = getRegexs(model.regPre,regHelp);
            model.regOut = getRegexs(model.helpOut.toString(),regExp);
        }else{
            if(model.help_test === ''){
                document.getElementById('help_out').style.display="none";
                model.regOut = getRegexs(model.regPre,new RegExp(model.regex_test,'gm'));
            }else{
                document.getElementById('help_out').style.display="block";
                model.helpOut = getRegexs(model.regPre,new RegExp(model.help_test,'gm'));
                model.regOut = getRegexs(model.helpOut.toString(),new RegExp(model.regex_test,'gm'));
            }
        }
        //Hack to adjust window size
        model.collapse();
        model.collapse();
    }

    model.collapse = () => {
        let ele = document.getElementById('modalCollapse');
        ele.classList.toggle('active');
        let content = ele.nextElementSibling;
        if (content.style.maxHeight){
            content.style.maxHeight = null;
        }else{
            content.style.maxHeight = content.scrollHeight + "px";
        }
    }

    model.addRegex = function () {
        model.modal_regexs.push({namHolder:"Example",name:"",regex:"",regHolder:"/*.*/", repeatedN: false, repeatedR: false})
        model.validateRegex({name:'',regex:''})
    }

    model.removeRegex = function (index) {
        let msg="Are you sure you'd like to delete \""+model.modal_regexs[index].name+"\"? After clicking OK the regex no longer will be available.";
        alertify.confirm('Delete confirmation',msg,()=>{ 
            if(model.modal_regexs[index].id !== undefined){
                $http({
                    method: 'POST',
                    url: api+'/api/regex/delete',
                    data: {
                        reg: model.modal_regexs[index]
                    }
                })
                .success(() => {
                    showMsg($scope.global.operations.success,"Data has been successfully deleted!")
                    if (model.modal_regexs.length > 1) {
                        model.modal_regexs.splice(index, 1)
                    }
                    return;
                })
                .error((error)=>{
                    alertError(error); 
                    return;
                })
            }else{
                if (model.modal_regexs.length > 1) {
                    model.modal_regexs.splice(index, 1)
                }
            }
        },{})
    }

    model.validateRegex = (reg) => {
        let tmpUniq = [];
        model.modal_regexs.forEach((element) => {
            if (tmpUniq.indexOf(element.regex) == -1){
                tmpUniq.push(element.regex);
                element.repeatedR=false;
            }
            else element.repeatedR=true;
        });
        if(reg.regex===''||model.modal_regexs.some(element => element.regex === '')||model.modal_regexs.some(element => element.repeatedR==true)){
            document.getElementById('saveFeed').disabled=true;
            return
        }else{
            document.getElementById('saveFeed').disabled=false;
        }
        tmpUniq = [];
        model.modal_regexs.forEach((element) => {
            if (tmpUniq.indexOf(element.name) == -1){
                tmpUniq.push(element.name);
                element.repeatedN=false;
            }
            else element.repeatedN=true;
        });
        if(reg.name===''||model.modal_regexs.find(element => element.name==="")||model.modal_regexs.find(element => element.repeatedN==true)){
            document.getElementById('saveFeed').disabled=true;
            return
        }else{
            document.getElementById('saveFeed').disabled=false;
        }
    }

    model.selectAll=(sensor_id)=>{
        if(document.getElementById(sensor_id+'selectAll').checked)
        {
            model.feeds.forEach((ele,index)=>{
                document.getElementById(sensor_id+'rememberMe'+index).checked = true;
            })
        }else{
            model.feeds.forEach((ele,index)=>{
                document.getElementById(sensor_id+'rememberMe'+index).checked = false;
            })
        }
    }

    model.cleanRegex = () => {model.regex_test = ''; model.help_test=''; model.regPre = ''; model.helpOut = ''; model.regOut = '';}
    
    

}

let timeConverter = (UNIX_timestamp) => {
    let a = new Date(UNIX_timestamp * 1000);
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let sec = a.getSeconds();
    let time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    return time;
}

let getRegexs = (text, reg) =>{
    let arr = [...text.matchAll(reg)];
    return arr.map((key)=> key[1]);
}

let showMsg = (op, msg) => {
    switch (op){
        case "Success":
            alertify.success(msg); 
            break;
        case "Warning":
            alertify.warning(msg);
            break;
        case "Error":
            alertify.error(msg)
            break;
    }
}
let alertError = (error) => alertify.dialog('alert').set({transition:'zoom',message: error, title:'Error!'}).show();

ctrl.$inject = ['$scope', '$http', 'Global', 'settings', '$location'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/feeds/manage_feeds.js
 **/